/**   
 * 统一权限接口统一管理
 */
 import { axiosPost } from './http';

 const prexfix = global.$config.api.apiUrl;
 // const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
 // const prexfix = 'http://biaozhunhua.zjht100.com'
 
 // 根据组织部门id获取部门下的人员信息接口
 export const resDeviceFindPage = (data) => {
   const params = {
     baseUrl: prexfix,
     data: data
   }
   return axiosPost(`data-api/data/data-server/resDevice/findPage`, params)
 };
 
 export const getstreamurl = (data) => {
  const params = {
    baseUrl: prexfix,
    data: data
  }
  return axiosPost(`data-api/data/data-server/resMonitor/getstreamurl`, params)
};

 
 
 let dataServerApi = {
    resDeviceFindPage,
    getstreamurl
  };
  
  export default dataServerApi;